var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { PwResetHttpServivce } from "../services/pw-reset-http.service";
import ApiError from "../components/ApiError";
import MailConfirmation from "../components/MailConfirmation";
import { withTranslation } from "react-i18next";
var ConfirmMailPage = /** @class */ (function (_super) {
    __extends(ConfirmMailPage, _super);
    function ConfirmMailPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            token: '',
            status: false
        };
        return _this;
    }
    ConfirmMailPage.prototype.parseToken = function () {
        var token = window.location.hash.substring(2).match(/[?&]token=([^&]*)/);
        history.replaceState(null, document.title, location.pathname);
        if (token) {
            this.setState({ token: token[1] });
            return token[1];
        }
        this.setState({ error: {
                message: "Bitte \u00FCberpr\u00FCfen Sie, ob der Link den richtigen Token-Wert hat"
            } });
        return '';
    };
    ConfirmMailPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, simple, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this.parseToken();
                        if (!token) {
                            return [2 /*return*/];
                        }
                        simple = new PwResetHttpServivce();
                        return [4 /*yield*/, simple.confirmRecoveryEmailAdress(token).catch(function (error) { return error.response; })];
                    case 1:
                        response = _a.sent();
                        switch (response.status) {
                            case 200:
                            case 204:
                                this.setState({ status: true });
                                break;
                            case 401:
                                this.setState({ errorType: "email_confirmation_token_invalid", status: false });
                                break;
                            default:
                                this.setState({ errorType: "uknown_error", error: { message: "Bitte überprüfen Sie, ob der Link den richtigen Token-Wert hat" } });
                                break;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfirmMailPage.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null),
            this.state.status ? React.createElement(MailConfirmation, null) : React.createElement(ApiError, { errorType: this.state.errorType, error: this.state.error }),
            React.createElement(Footer, null)));
    };
    return ConfirmMailPage;
}(React.Component));
export default withTranslation()(ConfirmMailPage);
